export const PERMISSION_DENIED_EVENT = 'colibri-permission-denied';

export function notifyPermissionDenied(): void {
  window.dispatchEvent(new Event(PERMISSION_DENIED_EVENT));
}
